import React from 'react'
import { useSelector } from 'hooks/use-redux'
import PasswordReset from './PasswordReset'

const PasswordResetContainer = (): React.ReactNode => {
  const user = useSelector(state => state.user)
  return <PasswordReset user={user} />
}

export default PasswordResetContainer
